import { Component, Prop, h } from '@stencil/core';
import Icon from '../svg/error.svg'

@Component({
  tag: 'cr-icon-error',
  styleUrl: '../cr-icon.css',
  shadow: true,
})

export class CrIconError {
  @Prop() size: string

  render() {
    return (
      <div
        class={this.size}
        innerHTML={Icon}
      />
    );
  }

}


